import React from 'react';

import { CARD_THEMES } from './card_theme';
import { IndexCard, getIndexCards } from './index_card';
import { LinkCard, getCardPaths } from './link_card';

import type { LinkCardRecord } from './link_card';
import type { TaskToolCall } from '../types';

interface TaskCard extends LinkCardRecord {
  displayName: string;
  parentLabel: string | null;
}

interface TaskCardsProps {
  toolCalls: TaskToolCall[];
}

export function TaskCards({ toolCalls }: TaskCardsProps) {
  return (
    <>
      {getCardPaths(toolCalls).map(path => (
        <LinkCard key={path} path={path} theme={CARD_THEMES.task}>
          {(task: TaskCard) => (
            <>
              <div className="fw-semibold text-truncate">{task.displayName}</div>
              {task.parentLabel && <div className="small text-muted text-truncate">{task.parentLabel}</div>}
            </>
          )}
        </LinkCard>
      ))}
      {getIndexCards(toolCalls).map(index => (
        <IndexCard index={index} key={index.path} label="tasks" pageName="Planner" theme={CARD_THEMES.task} />
      ))}
    </>
  );
}
